import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "fullWidth", "color", "label", "bottomLabel", "error", "inputRef", "focused", "labelProps", "fieldProps", "containerProps", "type", "value", "onChange", "loading", "placeholder"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, CircularProgress, Grid } from '@mui/material';
import { Icon } from '@elements/icon';
import { StyledAutocomplete, StyledAutocompleteTextField, StyledFormControl, StyledFormHelperErrorText, StyledFormHelperText, StyledInputLabel, StyleFormHelperWrapper } from './autocomplete-field.styles';
import CloseIcon from '@images/close.image.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var AutocompleteField = function AutocompleteField(_ref) {
  var name = _ref.name,
      fullWidth = _ref.fullWidth,
      color = _ref.color,
      label = _ref.label,
      bottomLabel = _ref.bottomLabel,
      error = _ref.error,
      inputRef = _ref.inputRef,
      focused = _ref.focused,
      labelProps = _ref.labelProps,
      fieldProps = _ref.fieldProps,
      containerProps = _ref.containerProps,
      type = _ref.type,
      value = _ref.value,
      onChange = _ref.onChange,
      loading = _ref.loading,
      placeholder = _ref.placeholder,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var inputName = name && "".concat(name, "-autocompletefield");

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var isError = !!error;
  var literalProps = {
    htmlFor: inputName,
    id: inputName,
    errorId: inputName && "".concat(inputName, "-error-text")
  };

  var changeHandler = function changeHandler(event, newValue) {
    if (onChange) {
      onChange({
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        target: {
          value: newValue === null || newValue === void 0 ? void 0 : newValue.value
        }
      });
    }
  };

  return /*#__PURE__*/_jsx(StyledFormControl, {
    error: isError,
    fullWidth: fullWidth,
    focused: focused,
    children: /*#__PURE__*/_jsxs(Grid, _objectSpread(_objectSpread({
      container: true,
      rowSpacing: 0.5,
      columnSpacing: 2,
      alignItems: "center"
    }, containerProps), {}, {
      children: [label && /*#__PURE__*/_jsx(Grid, _objectSpread(_objectSpread({
        item: true,
        xs: 12
      }, labelProps), {}, {
        children: /*#__PURE__*/_jsx(StyledInputLabel, {
          shrink: true,
          htmlFor: literalProps.htmlFor,
          children: label
        })
      })), /*#__PURE__*/_jsx(Grid, _objectSpread(_objectSpread({
        item: true,
        flex: "1 1"
      }, fieldProps), {}, {
        children: /*#__PURE__*/_jsxs(Box, {
          position: "relative",
          children: [/*#__PURE__*/_jsx(StyledAutocomplete, _objectSpread(_objectSpread({
            ref: inputRef,
            id: literalProps.id,
            "aria-describedby": inputName,
            fullWidth: fullWidth,
            color: color,
            clearIcon: /*#__PURE__*/_jsx(Icon, {
              src: CloseIcon,
              width: 10,
              height: 10
            }),
            renderInput: function renderInput(params) {
              return /*#__PURE__*/_jsx(StyledAutocompleteTextField, _objectSpread(_objectSpread({}, params), {}, {
                variant: "standard",
                placeholder: placeholder,
                InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
                  endAdornment: /*#__PURE__*/_jsxs(React.Fragment, {
                    children: [loading ? /*#__PURE__*/_jsx(CircularProgress, {
                      color: "inherit",
                      size: 10
                    }) : null, params.InputProps.endAdornment]
                  })
                })
              }));
            }
          }, restProps), {}, {
            onChange: function onChange(event, newValue) {
              return changeHandler(event, newValue);
            },
            isOptionEqualToValue: function isOptionEqualToValue(option, value) {
              return option.value === value.value;
            },
            clearText: t('components.autocomplete.clearText'),
            closeText: t('components.autocomplete.closeText'),
            loadingText: t('components.autocomplete.loadingText'),
            noOptionsText: t('components.autocomplete.noOptionsText'),
            openText: t('components.autocomplete.openText')
          })), isError && /*#__PURE__*/_jsx(StyleFormHelperWrapper, {
            children: /*#__PURE__*/_jsx(StyledFormHelperErrorText, {
              id: literalProps.errorId,
              children: error
            })
          }), bottomLabel && !isError ? /*#__PURE__*/_jsx(StyleFormHelperWrapper, {
            children: /*#__PURE__*/_jsx(StyledFormHelperText, {
              children: bottomLabel
            })
          }) : null]
        })
      }))]
    }))
  });
};

export { AutocompleteField };